<template>
    <div class="gglist">
    <div class="top" v-show="dataLoding == 1">
        <Table border :columns="adColumns" :data="this.tableList.tableData"></Table>
        <Page  size="small" @on-change="changePage" @on-page-size-change="changeSize" :total="page.total"  :show-total="true" :current="page.current" :page-size="page.pageSize"  placement="top" class="pagesimg"/>
    </div>
   <Spin fix class="bottom" v-show="dataLoding == 2">
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div>Loading</div>
    </Spin>

    </div>
</template>

<script>
/**规格属性伸缩框
 * @param params Object 所属的广告位的id
 *
 * set-ad-params Function 删除调用的父类方法
 *
 */
import common from '@/common/common.js';
    export default {
        name:'editad',
        components: {
        },
        props: {
            params: Object, // 当前点击的 那条数据 （对象）
        },
        data () {
        return {
            dataLoding:2,
            loading: true,
            type:1,//弹框打开类型 1添加 2编辑
            tableList:{//表格组
                hasSelectData:{},//已选中的行的数据
                tableData: []//表格数据
            },
            adBox:{//广告弹框组
                    posid:0,//上级广告位的ID
                    showAdModel:false,//广告弹框开关
                    editFormData:{},
                    pos_type:1,
                    callbackAdFn:()=>{}, //广告弹框的回调函数
                },
            page:{//分页排序
                    total:0,//总条数
                    pageSize:20,//每页条数
                    current:1,//当前页
                    key:'sort_num',
                    order:'desc'
                },
            adColumns: [
                {
                    title: '公司名',
                    key: 'agent_name',
                    minWidth:180,
                },
                {
                    title: '联系人',
                    key: 'contact_name',
                    minWidth: 80,
                },
                {
                    title: '手机',
                    key: 'mobile',
                    minWidth: 80,
                },
                {
                    title: '代理区域',
                    key: 'city',
                    minWidth: 80,
                    render: (h, params) => {
                        return h('span', params.row.province+params.row.city)
                    }
                },
                {
                    title: '代理结束时间',
                    key: 'end_time',
                    minWidth: 80,
                },
                {
                    title: '添加时间',
                    key: 'created_at',
                    minWidth: 140,
                },
            ]
        }
    },
    methods: {
        getData () {//获取
            let getData = {
                    params:{
                        page:this.page.current,
                        size:this.page.pageSize,
                        sortfield:this.page.key,
                        ascDesc:this.page.order,
                        id:this.params.row.id,
                        type:this.params.row.type
                        }
                }
                this.axios.get(this.config.urlArray.getAgentList,getData).then((result) => {
                    common.ajaxMsg(result.data);
                    let resData = result.data.data.list
                    //处理数组
                    this.$nextTick(() => {
                        this.tableList.tableData = resData
                        this.dataLoding = 1
                    })
                    this.page.total = result.data.data.paging.total
                    this.loading = false
                }).catch((err) => {
                    console.log(err)
                    common.msg('error','获取失败',()=>{})
                });
        },
        changePage (nowpage) {//切换分页
            this.page.current = nowpage
            this.getData()
        },
        changeSize (nowSize) {//切换每页显示条数
            this.page.pageSize = nowSize
            this.page.current = 1
            this.getData()
        }
    },
    mounted(){
       this.getData();
    }
    }
</script>
<style scope>
.ivu-poptip-confirm .ivu-poptip-body .ivu-icon{
    left: 20px;
}
td.ivu-table-expanded-cell{
    padding: 10px !important;
}
.gglist .ivu-table th{
    height: 30px !important;
}

</style>


